// extracted by mini-css-extract-plugin
module.exports = {"postsBlock":"MyPosts_postsBlock__gn-JB","item":"MyPosts_item__26ys3","postElement":"MyPosts_postElement__3MR3i"};